<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('Control de asistencia')"
      :directory="$t('registros')"
      :icon="'grid'"
    />
    <app-note
      class="mb-primary"
      :title="$t('note')"
      content-type="html"
      :notes="responsiveDatatableInstruction"
    />
    <div class="row">
      <!--  default filter  -->
      <th-audit-filter></th-audit-filter>
      <!--  tab filter  -->
      <!-- <session-audit-tab-filter></session-audit-tab-filter> -->
    </div>
  </div>
</template>

<script>
import thAuditFilter from "./th-filter";
export default {
  name: "session-audit-index",
  components: {
    thAuditFilter
  },
  data() {
    return { 
      responsiveDatatableInstruction: [this.$t("Registro y control de asistencia en la plataforma SISAC")],
    };
  },
};
</script>
